import React from 'react';
import Hero from './Hero';
import Welcome from './Welcome';
import Rooms from './Rooms';
import Conference from './Conference';
import WhyChoose from './WhyChoose';
import Contact from './Contact';

const Home = () => {
  return (
    <main>
      <Hero />
      <Welcome />
      <Rooms />
      <Conference />
      <WhyChoose />
      <Contact />
    </main>
  );
};

export default Home;